module.exports = __webpack_public_path__ + "static/media/drdelicacy.5789f8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drdelicacy.png
// module id = 28
// module chunks = 0